import LoadingButton from '@mui/lab/LoadingButton';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import ONBOARDING_TOOLTIP_CLASS_NAME from '../../../theme/constants/tooltip';

const ShoppingCartSummaryActionButton = ({
  tooltipTitle,
  loading,
  label,
  ...props
}) => (
  <Tooltip title={tooltipTitle} classes={{ tooltip: ONBOARDING_TOOLTIP_CLASS_NAME }}>
    <span>
      <LoadingButton
        variant="contained"
        color="primary"
        sx={{
          width: '100%',
          fontSize: { xs: 10, md: 14 },
          minHeight: 40,
        }}
        loading={loading}
        {...props}
      >
        {label}
      </LoadingButton>
    </span>
  </Tooltip>
);

ShoppingCartSummaryActionButton.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  tooltipTitle: PropTypes.string,
  loading: PropTypes.bool,
};

ShoppingCartSummaryActionButton.defaultProps = {
  tooltipTitle: null,
  loading: false,
};

export default ShoppingCartSummaryActionButton;
